import { useState, useRef } from "react";
import { motion } from "framer-motion";
import "./HeroSection.css";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export default function HeroSection() {
  const [parallax, setParallax] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  const handleDownload = () => {
    const url = process.env.PUBLIC_URL + "/img/GRIACH-TAHAR-CV.pdf";
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "GRIACH-TAHAR-CV.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // tiny parallax: update transform based on mouse position inside hero
  const handleMouseMove = (e) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const dx = (e.clientX - cx) / rect.width; // -0.5 .. 0.5
    const dy = (e.clientY - cy) / rect.height;
    // make the effect subtle
    setParallax({ x: dx * 20, y: dy * 12 });
  };

  const handleMouseLeave = () => {
    setParallax({ x: 0, y: 0 });
  };

  return (
    <section
      id="heroSection"
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className="hero-section"
    >
      {/* animated gradient + shapes live in CSS */}
      <div className="hero-bg">
        <div
          className="blob blob-1"
          style={{ transform: `translate(${parallax.x * -0.6}px, ${parallax.y * -0.4}px)` }}
        />
        <div
          className="blob blob-2"
          style={{ transform: `translate(${parallax.x * 0.8}px, ${parallax.y * 0.5}px)` }}
        />
        <div
          className="blob blob-3"
          style={{ transform: `translate(${parallax.x * -0.4}px, ${parallax.y * 0.9}px)` }}
        />
        <div className="star-overlay" aria-hidden />
      </div>

      <div className="hero-inner">
        {/* LEFT: text */}
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          <p className="hero-pretitle">Hey, I'm <strong>Tahar</strong> 👋</p>
          <h1 className="hero-title">
            <span className="accent">Full Stack</span> <br />
            Developer
          </h1>
          <p className="hero-desc">
            Passionate about building fast, maintainable web apps with clean UI and robust backends.
            I work with React, Laravel, Express, and Python. Let’s craft something great together.
          </p>

          <div className="hero-cta">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              onClick={handleDownload}
              className="btn-download"
            >
              Download CV
            </motion.button>

            <a className="btn-contact" href="#Contact">Contact Me</a>
          </div>
        </motion.div>

        {/* RIGHT: image with floating + parallax + hover glow */}
        <motion.div
          className="hero-art-wrap"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.15, ease: "easeOut" }}
          style={{
            transform: `translate(${parallax.x * 0.8}px, ${parallax.y * 0.6}px)`,
          }}
        >
              <DotLottieReact
              src="./img/hero.lottie"
              loop
              autoplay
              fit
              width={200}
              height={200}
            />
          {/* <motion.img
            src="./img/about.svg"
            alt="Hero Illustration"
            className="hero-art"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 4.2, repeat: Infinity, ease: "easeInOut" }}
            whileHover={{ scale: 1.03, rotate: -1 }}
            draggable={false}
          />
          <div className="art-glow" /> */}
        </motion.div>
      </div>
    </section>
  );
}
